<template>

    <tbody>

        <tr v-for="item in inscriptions" :key="item.id">

            <td>
                <div class="d-flex sm-gap">
                    <img class="flag_img" v-if="item.champs.pays"
                        :src="'https://sportips.fr/Flags/' + item.champs.pays + '.jpg'" :alt="item.champs.pays" />

                    <div>
                        {{ item.nom.toUpperCase() }} {{ item.prenom.charAt(0).toUpperCase() + item.prenom.slice(1) }}
                        <span v-if="item.champs.equipe_name && item.champs.equipe_name != ''">- Equipe {{
                            item.champs.equipe_name }}</span>

                        <span v-if="item.champs.nom_equipe && item.champs.nom_equipe != ''">{{ item.champs.nom_equipe
                        }}</span>
                    </div>
                    <div v-if="mode == 'admin'">
                        <div v-if="item.affiche == 0">
                            <v-chip size="small" density="compact" color="red-darken-4" variant="elevated">Non affiché
                                au
                                public</v-chip>
                        </div>
                        <div v-if="item.supprime == 1">
                            <v-chip size="small" density="compact" color="red-darken-4"
                                variant="elevated">Supprimé</v-chip>
                        </div>
                        <div v-if="item.transfere == 1">
                            <v-chip size="small" density="compact" color="red-darken-4"
                                variant="elevated">Transferé</v-chip>
                        </div>
                        <div v-if="item.from_transfert == 1">
                            <v-chip size="small" density="compact" color="red-darken-4" variant="elevated">Provient d'un
                                transfert</v-chip>
                        </div>
                    </div>
                </div>
            </td>




            <td>
                <div v-if="item.supprime == 1"><v-icon color="dark-red">mdi-close</v-icon></div>
                <div v-else><v-icon v-if="item.valide == 1" color="dark-green">mdi-check</v-icon> <v-icon v-else
                        color="dark-red">mdi-close</v-icon></div>
            </td>

            <td v-if="mode == 'admin'">
                <router-link :to="{ name: 'EditInscriptionAdmin', params: { id_inscription: item.id } }">
                    <v-btn size="small" variant="text" color="primary-dark"><v-icon class="mr-1">mdi-pencil</v-icon>
                        Editer
                    </v-btn>
                </router-link>
                <a :href="base_url + 'billet/get.php?id_inscrit=' + item.id" target="_blank"><v-btn size="small"
                        variant="text" color="primary-dark"><v-icon class="mr-1">mdi-download</v-icon>
                        Billet</v-btn></a>
            </td>
        </tr>
    </tbody>
</template>

<script>
export default {
    name: 'InscriptionTbody',
    props: ["mode", "inscriptions"],
    data() {
        return {
            base_url: process.env.VUE_APP_API_BASE,
            // Define your component data here
        };
    },
    methods: {
        // Define your component methods here
    },
    computed: {
        // Define your computed properties here
    },
    mounted() {


        // Lifecycle hook when the component is mounted
    }
};
</script>

<style scoped>
/* Your component styles go here */
</style>